import { render, staticRenderFns } from "./releaseEquityDetail.vue?vue&type=template&id=c87b023c&scoped=true&"
import script from "./releaseEquityDetail.vue?vue&type=script&lang=js&"
export * from "./releaseEquityDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseEquityDetail.vue?vue&type=style&index=0&id=c87b023c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b023c",
  null
  
)

export default component.exports